
import { assetsInitialState, DealRoomAsset, DealRoomEditState } from "src/types/dealRoom";

export enum ModuleEnum {
  OVERVIEW = 'overview',
  ASSETS = 'assets',
  PEOPLE = 'people',
  ACTIVITY = 'activity',
  ENGAGE = 'engage',
}

export enum AssetsLayoutEnum {
  GRID = 'grid',
  LIST = 'list'
}
export interface MenuState {
  primaryAction: 'view' | 'edit' | 'edit-banner';
  secondaryAction?: 'save' | 'reset' | 'add-section' | 'crop' | 
  'apply-crop' | 'filter' | 'rename' | 'add-asset' | 'position' | 'asset-viewer' |
  'social-share' | 'reset-layout' | null;
  data?: any;
}

export interface SectionState {
  uid?: string;
  id?: string;
  name: string;
  assets: assetsInitialState;
  loading: boolean;
  loaded: boolean;
  index: number;
  active: boolean;
}

export interface StaticAssetsLayoutProps {
  assets: assetsInitialState;
  loading: boolean;
  activeAssetLayout: AssetsLayoutEnum;
  // eslint-disable-next-line no-unused-vars
  onClick: (asset: DealRoomAsset) => void;
  fetchAssetsForPage: (page: number) => void;
  canAddAsset: boolean;
}
export interface AssetLayoutProps {
  dealRoom: DealRoomEditState; 
  section?: number;
  visible: boolean;
  assets: assetsInitialState;
  loading: boolean;
  activeAssetLayout: AssetsLayoutEnum;
  assetsClassName?: string;
  fetchAssetsForPage: (page: number) => void;
  // eslint-disable-next-line no-unused-vars
  onClick: (asset: DealRoomAsset) => void;

  // eslint-disable-next-line no-unused-vars
  onRemove: (asset: DealRoomAsset) => void;
  
  // eslint-disable-next-line no-unused-vars
  onMove: (updatedAssets: DealRoomAsset[]) => void;

  // eslint-disable-next-line no-unused-vars
  onMoveToSection: (section: number, asset: DealRoomAsset) => void;
  isRenderingSection?: boolean;

}

export interface SectionBarProps {
  overSection: string | null | undefined;
  dealRoom: DealRoomEditState;
  sections: SectionState[];
  selected: number;
  // eslint-disable-next-line no-unused-vars
  onSelectionChange: (index: number) => void;
  // eslint-disable-next-line no-unused-vars
  // eslint-disable-next-line no-unused-vars
  onMove: (from: number, to: number) => void;
  // eslint-disable-next-line no-unused-vars
}